import { HStack, Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

export default function Typing() {
    const bounce = keyframes`
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
  `;
    const animation = `${bounce} 1.4s infinite ease-in-out both`;

    return (
        <HStack spacing={1} align="center" h="20px">
            <Box
                w="4px"
                h="4px"
                bg="gray.500"
                rounded="full"
                animation={animation}
                style={{ animationDelay: "0s" }}
            />
            <Box
                w="4px"
                h="4px"
                bg="gray.500"
                rounded="full"
                animation={animation}
                style={{ animationDelay: "0.2s" }}
            />
            <Box
                w="4px"
                h="4px"
                bg="gray.500"
                rounded="full"
                animation={animation}
                style={{ animationDelay: "0.4s" }}
            />
        </HStack>
    );
}
